var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"fill-current",attrs:{"width":"19","height":"19","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3 11.5l17-7.5-6.5 17-2.5-7z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }